<template>
  <v-container
    v-show="viewPage"
    fluid
  >
    <div class="text-h2">
      Descarga Guión
    </div>
    <v-subheader>Es necesario comprar y activar al menos una licencia para acceder a los guiones del juego. El profesor también tendrá este acceso cuando algún padre le haya asignado al menos un alumno.</v-subheader>
    <v-row
      align="center"
      justify="start"
    >
      <v-col
        cols="12"
        sm="6"
      >
        <v-subheader class="text-h3">
          Episodio 1
        </v-subheader>
      </v-col>
    </v-row>
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        class="text-center"
      >
        <v-btn
          v-for="(file, i) in files"
          :key="i"
          class="mb-2"
          outlined
          color="primary"
          block
          :disabled="disabledDownload"
          @click="download(file.url)"
        >
          <v-icon left>
            mdi-file-pdf
          </v-icon>
          {{ file.name }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        viewPage: false,
        files: [
          { name: 'Prólogo', url: 'https://storage.googleapis.com/videojuego-sh.appspot.com/Guiones/Historieta_Pr%C3%B3logo.pdf' },
          { name: 'Nivel 1', url: 'https://storage.googleapis.com/videojuego-sh.appspot.com/Guiones/Historieta_%20Nivel%201.pdf' },
          { name: 'Nivel 2', url: 'https://storage.googleapis.com/videojuego-sh.appspot.com/Guiones/Historieta_%20Nivel%202.pdf' },
          { name: 'Nivel 3', url: 'https://storage.googleapis.com/videojuego-sh.appspot.com/Guiones/Historieta_%20Nivel%203.pdf' },
          { name: 'Nivel 4', url: 'https://storage.googleapis.com/videojuego-sh.appspot.com/Guiones/Historieta_%20Nivel%204.pdf' },
          { name: 'Nivel 5', url: 'https://storage.googleapis.com/videojuego-sh.appspot.com/Guiones/Historieta_%20Nivel%205.pdf' },
          { name: 'Nivel 6', url: 'https://storage.googleapis.com/videojuego-sh.appspot.com/Guiones/Historieta_%20Nivel%206.pdf' },
          { name: 'Nivel 7', url: 'https://storage.googleapis.com/videojuego-sh.appspot.com/Guiones/Historieta_%20Nivel%207.pdf' },
          { name: 'Nivel 8', url: 'https://storage.googleapis.com/videojuego-sh.appspot.com/Guiones/Historieta_%20Nivel%208.pdf' },
          // { name: 'Lista de Frutas', url: 'https://storage.googleapis.com/videojuego-sh.appspot.com/Guiones/Lista%20de%20Frutas.pdf' },  
        ],
      }
    },
    computed: {
      ...mapState(['licenses', 'user']),
      ...mapState(['userData', 'user']),
      disabledDownload () {

         if (this.userData.studentsAssigned === null)
         return false;

          let total = this.userData.studentsAssigned.length;
          total += this.licenses.length;

          console.log('licences: '+total)
        return total === 0
      },
    },
    methods: {
      download (url) {
        window.open(url, '_blank')
      },
    },
    beforeRouteEnter (to, from, next) {
      next(async vm => {
        const user = vm.user
        if (user.type === 'tutor' || user.type === 'parent') {
          vm.viewPage = true
          next()
        } else {
          console.log('Está intentando ingresar a una pagina no autorizada.')
          next({
            name: 'Home',
          })
        }
      })
    },
  }
</script>
